import axios from "axios";

export const fetchDeleteCompany = (companyId: string) => {
    return axios.delete(`/api/company/${companyId}`);
};
